import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import api from "../lib/Urls";

const AdminRoute = () => {
  const [state, setState] = useState("checking");

  useEffect(() => {
    let cancelled = false;

    api
      .get("/api/admin/session")
      .then(() => {
        if (!cancelled) setState("allowed");
      })
      .catch(() => {
        // Fail closed and silently. The backend remains the actual security
        // boundary; this component only avoids exposing admin UI.
        if (!cancelled) setState("denied");
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (state === "checking") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background px-4">
        <div className="flex flex-col items-center gap-3 text-center">
          <div
            className="h-9 w-9 rounded-full border-2 border-primary/30 border-t-primary animate-spin"
            aria-hidden="true"
          />
          <p className="text-sm font-medium text-foreground">
            Loading user management...
          </p>
        </div>
      </div>
    );
  }
  if (state === "denied") return <Navigate to="/" replace />;

  return <Outlet />;
};

export default AdminRoute;
